module.exports = __webpack_public_path__ + "img/gpu_cover_a.4ff2867e.png";